export const AUTH_TOKEN_UPDATED = 'rg-admin:token-updated';
export const AUTH_SESSION_EXPIRED = 'rg-admin:session-expired';

export function emitTokenUpdated(accessToken: string): void {
    window.dispatchEvent(new CustomEvent<string>(AUTH_TOKEN_UPDATED, { detail: accessToken }));
}

export function emitSessionExpired(): void {
    window.dispatchEvent(new CustomEvent(AUTH_SESSION_EXPIRED));
}
